<template>
  <div class="container">
    <a-breadcrumb separator=">">
      <a-breadcrumb-item href="" @click.native="() => $router.push('/')">首页</a-breadcrumb-item>
      <a-breadcrumb-item>{{ layoutTitle }}</a-breadcrumb-item>
    </a-breadcrumb>

    <a-spin :spinning="loading" tip="加载中...">
      <div class="content">
        <a-card hoverable class="item-card" v-for="item in articleList1" :key="item.id" @click="onDetail(item)">
          <img v-lazy="item.articleCoverUrl" alt="" />
          <div class="info">
            <div class="title">
              {{ item.articleTitle }}
            </div>
            <div class="time">
              {{ $dayjs(item.createTime).format('YYYY-MM-DD') }}
            </div>
          </div>
        </a-card>
      </div>
    </a-spin>

    <a-pagination show-quick-jumper v-model="currentpage" :total="total" @change="onChange" />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { getList } from '@/api/article'
export default {
  components: {},
  data() {
    return {
      loading: false,
      articleList1: [],
      articleTypeId: '',
      currentpage: 1,
      total: 0
    }
  },
  computed: {
    ...mapGetters({
      layoutTitle: 'layout/lyaoutTitle'
    })
  },

  created() {
    this.searchKey = this.$route.query.searchKey;
    this.articleTypeId = this.$route.query.typeId
    this.currentpage = this.$route.query.page ? Number(this.$route.query.page) : 1
    this.getArticleList()
  },
  methods: {
    ...mapMutations({
      setLayoutTitle: 'layout/setLayoutTitle'
    }),

    onChange(val) {
      this.currentpage = val
      this.getArticleList()
    },

    async getArticleList() {
      this.articleList1 = [];
      this.loading = true;
      const params = {
        data: {
          articleTypeId: this.articleTypeId,
          articleTitle: this.searchKey
        },
        page: this.currentpage,
        pageSize: 12 //每页记录数 默认为10
      }
      const { data, code, total } = await getList(params)
      this.loading = false;
      if (code == 200) {
        this.articleList1 = data;
        this.total = total;
      }
    },
    toHome() {
      this.$router.push('/')
    },
    onDetail(data) {
      if (data.isOuterChain == 0) {
        //外链
        window.open(data.articleContent);
      } else {
        this.$router.push({
          path: "/articleDetail",
          query: {
            articleId: data.id,
            fromPage: this.currentpage,
            typeId: this.articleTypeId
          },
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fontColor1 {
  color: #fe695c;
  font-size: 14px;
}

.fontColor {
  color: #8e8e8e;
  font-size: 14px;
}

.fontstyle {
  font-size: 14px;
  cursor: pointer;
}

.center {
  margin-top: 52px;
  text-align: center;

  .inform {
    margin: 12px 0;
  }
}

.flex {
  display: flex;
  justify-content: space-evenly;
}

.container {

  .content {
    min-height: 550px;
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;

    .item-card {
      width: 380px;
      margin: 0 7px;
      margin-bottom: 15px;

      img {
        height: 100%;
        width: 50%;
        margin-right: 12px;
      }

      .info {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;

        .time {
          font-size: 14px;
          color: #999;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .title {
          font-size: 14px;
          width: 240px;
          font-weight: bold;
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2; // 2行省略
          overflow: hidden;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}

/deep/.ant-card-body {
  display: flex;
  width: 200px;
  height: 120px;
}
</style>
